import * as React from 'react';

import { GenerateQuestionDialogContent } from '~teacher/components/ResultsGrid/Insights/GenerateQuestions/Layout/GenerateQuestionDialogContent';

interface SpecificStudentProps {
  backToGenerationType: () => void;
}

export function SpecificStudent({
  backToGenerationType,
}: SpecificStudentProps) {
  return (
    <GenerateQuestionDialogContent
      header={
        <GenerateQuestionDialogContent.Header onBack={backToGenerationType}>
          Select a student(s) to generate an assessment for their areas of
          improvement.
        </GenerateQuestionDialogContent.Header>
      }
    >
        Not Done Yet.
    </GenerateQuestionDialogContent>
  );
}
